import { PlayerBase } from '@24i/player-base';
import { useEffect, useState } from 'react';
import storeActions from 'Store/storeActions';
import { useStore } from 'Store';

const useVolume = (playerInstance: PlayerBase) => {
    const { deviceStorageState, deviceStorageDispatch } = useStore();
    const [volume, setVolumeVal] = useState(deviceStorageState.playerVolume);

    useEffect(() => {
        const onVolumeChange = () => {
            setVolumeVal(playerInstance.volume);
        };
        if (playerInstance) {
            playerInstance.volume = volume;
        }
        playerInstance?.addEventListener?.('volumechange', onVolumeChange);
        return () => {
            playerInstance?.removeEventListener?.('volumechange', onVolumeChange);
        };
    }, [playerInstance]);

    const setVolume = (newVolume: number) => {
        deviceStorageDispatch({
            type: storeActions.setPlayerVolume,
            payload: newVolume
        });
        playerInstance.volume = newVolume;
        setVolumeVal(newVolume);
    };

    return { volume, setVolume };
};

export default useVolume;
